import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import "./index.css";
import "typeface-roboto";

import { createMuiTheme, ThemeProvider } from "@material-ui/core";
import common from "@material-ui/core/colors/common";

const theme = createMuiTheme({});

theme.overrides = {
  MuiButton: {
    root: {
      color: common.white,
      "&.Mui-disabled": {
        color: common.white
      },
      "&.MuiButton-outlined": {
        borderColor: common.white
      },
      "&.MuiButton-outlined.Mui-disabled": {
        borderColor: common.white
      }
    }
  },
  MuiInputLabel: {
    root: {
      color: common.white,
      "&.Mui-focused": {
        color: common.white
      },
      "&.Mui-disabled": {
        color: common.white
      }
    }
  },
  MuiOutlinedInput: {
    input: {
      color: common.white
    },
    focused: {
      borderColor: common.white
    },
    root: {
      "& fieldset": {
        borderColor: common.white
      },
      "&:hover fieldset": {
        borderColor: common.white
      },
      "&:hover .MuiOutlinedInput-notchedOutline": {
        borderColor: common.white
      },
      "&.Mui-focused fieldset": {
        borderColor: common.white
      },
      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        borderColor: common.white
      },
      "&.Mui-disabled fieldset": {
        borderColor: common.white
      },
      "&.Mui-disabled .MuiOutlinedInput-notchedOutline": {
        borderColor: common.white
      }
    }
  }
};

ReactDOM.render(
  <ThemeProvider theme={theme}>
    <App />
  </ThemeProvider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
